import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    bg: 'blackAlpha.500',
    w: ['100% + 8px', null, '100%'],
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
    borderRadius: ['none', null, 'md'],
    minH: '8',
    h: 'auto',
    px: '4',
    mx: ['-2', null, '0'],
    my: '3',
    sx: {
      '&[data-isonsportsall="true"]': {
        pb: '0',
      },
    },
  },
  link: {
    boxShadow: 'none',
    border: 'none',
    fontSize: 'sm',
    borderRadius: 'none',
    fontFamily: 'Staatliches',
    lineHeight: '2',
    h: '10',
    color: 'gamma.200',
    borderBottom: '3px solid',
    borderBottomColor: 'transparent',
    textTransform: 'uppercase',
    px: '3',
    pt: '2',
    pb: '1',
    sx: {
      '&.active': {
        border: 'none',
        borderBottom: '3px solid',
        color: 'gamma.500',
        borderBottomColor: 'gamma.500',
      },
    },
  },
};
